<template>
  <div>
    <div class="container" style="margin-top: 100px">
      <div class="row">
        <div class="col-md-12" style="text-align: left; margin-bottom: 61px">
          <span class="" style="font-size: 33px"
            >{{ housetitle }}{{ houselou }}号{{ househao }}室</span
          >
        </div>
      </div>
      <div class="row" style="">
        <div class="col-md-7">
          <div class="block">
            <el-carousel
              height="500px"
              arrow="always"
              :interval="7000"
              style="width: 100%"
            >
              <el-carousel-item v-for="(item, index) in imglist" :key="index">
                <img :src="item" style="" class="housedetail1" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="col-md-5">
          <div class="row" style="">
            <div class="col-md-6">
              <span class="housedetail2">{{ houseprice }}元/月</span>
            </div>
            <div class="col-md-3">
              <span class="housedetail3">{{ houseyongjin }}</span>
              <span class="housedetail3">%</span>佣金
            </div>
          </div>
          <div class="row housedetail4" style=""></div>
          <div class="row housedetail5" style="">
            <div class="col-md-4" style="text-align: right; margin-left: -17px">
              <span class="housedetail6">付款方式:</span>
            </div>
            <div class="col-md-8" style="text-align: left; margin-left: -34px">
              <span class="housedetail7">{{ houseyajin }}{{ housefuzu }}</span>
            </div>
          </div>
          <div class="row housedetail5">
            <div class="col-md-4 housedetail8copy" style="">
              <span class="housedetail6">小区名称:</span>
            </div>
            <div class="col-md-8 housedetail9" style="">
              <span class="housedetail7">{{ housename }}</span>
            </div>
          </div>
          <!-- <div class="row housedetail5">
            <div class="col-md-4 housedetail8" style="">
              <span class="housedetail6">楼号:</span>
            </div>
            <div class="col-md-8 housedetail9" style="">
              <span class="housedetail7">{{houselou}}号{{househao}}室</span>
            </div>
          </div>-->
          <div class="row housedetail5">
            <div class="col-md-4 housedetail8" style="">
              <span class="housedetail6">面积:</span>
            </div>
            <div class="col-md-8 housedetail9" style="">
              <span class="housedetail7">{{ houssesize }}m²</span>
            </div>
          </div>
          <div class="row housedetail5">
            <div class="col-md-4 housedetail8" style="">
              <span class="housedetail6">户型:</span>
            </div>
            <div class="col-md-8 housedetail9" style="">
              <span class="housedetail7">
                <span>{{ houseroom }}</span
                >室 <span>{{ houseting }}</span
                >厅 <span>{{ housewei }}</span
                >卫
              </span>
            </div>
          </div>
          <div class="row housedetail5">
            <div class="col-md-4 housedetail8" style="">
              <span class="housedetail6">类型:</span>
            </div>
            <div class="col-md-8 housedetail9" style="">
              <span class="housedetail7">{{ housetype }}</span>
            </div>
          </div>
          <div class="row housedetail5">
            <div class="col-md-4 housedetail8" style="">
              <span class="housedetail6">区域:</span>
            </div>
            <div class="col-md-8 housedetail9" style="">
              <span class="housedetail7">{{ housequyu }}</span>
            </div>
          </div>
          <div class="row housedetail5">
            <div class="col-md-4 housedetail8">
              <span class="housedetail6">地铁:</span>
            </div>
            <div v-if="housexianlu" class="col-md-8 housedetail9">
              <span class="housedetail7">
                <span>{{ housexianlu }}</span
                >号线&nbsp;&nbsp;
                <span>{{ housestation }}</span>
              </span>
            </div>
            <div v-else class="col-md-8 housedetail9">
              <span class="housedetail7">
                <span>暂无</span>
              </span>
            </div>
          </div>
          <div class="row housedetail4"></div>
          <div class="row housedetail5">
            <div class="col-md-4" style="margin-left: 42px; margin-top: 18px">
              <span class="housedetail10" @click="downloadphoto()"
                >下载图片</span
              >
            </div>
            <div class="col-md-8" style=""></div>
          </div>
          <div class="row housedetail11"></div>
          <div class="row housedetail5">
            <div class="col-md-11" style="">
              <span
                class="housedetail12"
                @click="seePusherPhone"
                data-toggle="modal"
                >拨打联系电话</span
              >
            </div>
            <div class="col-md-1" style=""></div>
          </div>
        </div>
      </div>
      <div class="content row">
        <div class="col-md-6">
          <div class="des">
            <h2>房屋设施</h2>
            <ul class="row">
              <li class="col-md-4" v-for="todosheshi in sheshidata">
                <div>
                  <img :src="todosheshi.icon" alt="" style="" />
                  <span>{{ todosheshi.name }}</span>
                </div>
              </li>
            </ul>
          </div>

          <div class="des">
            <h2>简介</h2>
            <p>{{ housejianjie }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <h2>地理位置</h2>
          <div id="map" style="height: 300px"></div>
        </div>
      </div>
    </div>
    <SlideUpAlert
      :show="showAlert"
      title="安全警示"
      :content="alertContent"
      @close="onAlertClose"
    />
    <!-- 模态框（Modal） -->
    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="background: #000; margin-top: 172px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              style="color: #fff; opacity: 1"
            >
              &times;
            </button>
            <h4
              class="modal-title"
              id="myModalLabel"
              style="color: #fff;width: 90%;"
            >
              亲，麻烦您打开微信，扫码后可直接电话联系房东，联系过后麻烦对此房源房态进行标注!
            </h4>
          </div>
          <div class="modal-body">
            <!-- <div class="fangtaifg">
              <img
                src="../assets/images/callphonehj.svg"
                style="width: 55px; height: 55px"
              />
              <span style="color: #fff; margin-top: 17px">{{ seePhone }}</span>
            </div> -->
            <div class="fangtaifg" v-if="qrcodeimg">
              <img :src="qrcodeimg" alt="" />
            </div>

            <div class="calldata">
              <span style="color: #fff; margin-top: 17px"
                >联系我时，请告知在【职业房东网】上看到的哟</span
              >
            </div>
            <div class="fangtai1">
              <!-- <span class="fangtai2" @click="fangtmark(2)">在租</span> -->
              <el-button
                style="width: 20%"
                @click="fangtmark(2)"
                :loading="loadinggone"
                class="fangtai2"
                >在租</el-button
              >
              <!-- <span class="fangtai3" @click="fangtmark(1)">已租</span> -->
              <el-button
                style="width: 20%"
                @click="fangtmark(1)"
                :loading="loadinggtwo"
                class="fangtai3"
                >已租</el-button
              >
              <el-button
                style="width: 20%"
                @click="fangtmark(3)"
                :loading="loadinggthree"
                class="fangtai4"
                >未接通</el-button
              >
              <!-- <span class="fangtai4" @click="fangtmark(3)">未接通</span> -->
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal -->
    </div>
    <!-- 微信小程序二维码 -->
    <div class="qrcode" v-if="qrcodeimg">
      <img :src="qrcodeimg" alt="" />
      <p>手机扫描查看详情</p>
    </div>
    <!-- 聊天-->
    <div
      class="chat"
      :class="{ blink: isBlinking }"
      @mouseover="stopBlinking"
      @mouseleave="startBlinking"
      @click="toChat"
    >
      <img src="../assets/images/chat.svg" alt="" />
      <p>点击在线咨询</p>
    </div>
    <!-- 模态框（Modal） -->
    <div
      class="modal fade"
      id="myModaltwo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="background: #000; margin-top: 172px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              style="color: #fff; opacity: 1"
            >
              &times;
            </button>
            <h4 class="modal-title" id="myModalLabel" style="color: #fff">
              感谢您的标注，送您锦鲤，祝您好运
            </h4>
          </div>
          <div class="modal-body">
            <img src="../assets/images/jingli.svg" width="155px;" />
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal -->
    </div>
  </div>
</template>

<script>
import https from "../http.js";
import qs from "qs";
import $ from "jquery";
import SlideUpAlert from "../components/SlideUpAlert";
export default {
  components: {
    SlideUpAlert,
  },
  data() {
    let self = this;
    const safetyIcon = require("@/assets/images/jing.png");
    return {
      showAlert: true,
      alertContent: `
        <div class="safety-content">
          <img src="${safetyIcon}" alt="安全图标" class="safety-icon">
          <div class="safety-text">
            签约前，请务必认真审核出租方的出租资格(产证，身份证，委托书)，避免由于个人审核疏忽，造成租房损失。
            平台仅提供信息交流，未对联系人出租权逐一审核，不承担交易责任。
            您也可以选择扫描房源详情二维码进入小程序，选择平台服务，为您的租房保驾护航。
          </div>
        </div>
      `,
      qrcodeimg: "",
      imglist: [],
      coverimg: "",
      height: "",
      seePhone: "",
      housetitle: "",
      houseprice: "",
      houseyongjin: "",
      houseyajin: "",
      housefuzu: "",
      housename: "",
      houselou: "",
      househao: "",
      houseroom: "3",
      houseting: "1",
      housewei: "1",
      housetype: "",
      housequyu: "",
      housexianlu: "",
      housestation: "",
      housejianjie: "",
      houseidd: "",
      sheshidata: [],
      showphone: "",
      fdname: "",
      houssesize: "",
      loadinggone: false,
      loadinggtwo: false,
      loadinggthree: false,
      lat: "",
      lng: "",
      user_name: "",
      isBlinking: true,
      to_uid: "",
      to_name: "",
      to_avatarimg: "",
    };
  },

  methods: {
    startBlinking() {
      this.isBlinking = true;
    },
    stopBlinking() {
      this.isBlinking = false;
    },
    toChat() {
      var userId = this.$cookies.get("userid");
      if (!userId) {
        this.$alert("前往登录？", "登陆已过期，请重新登陆", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "cancel") {
              this.$router.push({ path: "/index" });
            } else {
              this.$router.push({ path: "/login" });
            }
          },
        });
        return false;
      }
      this.$router.push({
        name: "Chat",
        params: {
          houseid: this.houseidd,
          fytitle:
            this.housetitle + this.houselou + "号" + this.househao + "室",
          house_img: this.coverimg,
          station: this.housestation,
          district: this.housequyu,
          price: this.houseprice,
          to_uid: this.to_uid,
          to_name: this.to_name,
          to_avatarimg: this.to_avatarimg,
          type_message: 1,
        },
      }); // 只能用 name
    },
    // 高德地图定位搜索
    getSearchLocalhost() {
      var _this = this;
      var marker;
      //初始化地图对象，加载地图
      var map = new AMap.Map("map", {
        resizeEnable: true,
        lang: "zh_en",
      });
      var inputsearch = this.housetitle;
      // 高德地图搜索
      map.plugin("AMap.PlaceSearch", function() {
        var placeSearch = new AMap.PlaceSearch({
          city: "上海市",
          pageSize: 5,
        });
        // 获取高德地图搜索地址
        placeSearch.search(inputsearch, function(status, data) {
          var pois = data.poiList.pois;
          //获取经纬度
          _this.lat = pois[0].location.lat;
          _this.lng = pois[0].location.lng;
          var position = new AMap.LngLat(_this.lng, _this.lat); // 标准写法
          // 获取中心点定位缩放18
          map.setZoomAndCenter(18, [_this.lng, _this.lat]);
          // 获取地图中心点
          // var currentCenter = map.getCenter(position)
          // 设置定位标签Icon点
          if (marker == null || marker == "undefind") {
            marker = new AMap.Marker({
              icon: new AMap.Icon({
                size: new AMap.Size(150, 160), //图标大小
                image: "https://www.move2china.com/static/img/housedingwei.svg",
              }),
              position: [_this.lng, _this.lat],
            });
            marker.setMap(map);
            _this.updateHouseLatLng();
          } else {
            marker.setPosition(new AMap.LngLat(self.lng, self.lat));
          }
        });
        map.setFitView();
      });
    },
    updateHouseLatLng() {
      let param = {
        houseId: this.houseidd,
        houseLng: this.lng,
        houseLat: this.lat,
      };
      https
        .fetchPost("/house-detail/update-house-lat-lng", qs.stringify(param))
        .then((data) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    // 判断是否为私盘
    seePusherPhone() {
      if (this.user_name != "") {
        this.showusername();
      } else {
        this.showuser();
      }
    },
    // 显示房源信息电话
    showuser() {
      // var useridd = sessionStorage.getItem("userid");
      var useridd = this.$cookies.get("userid");
      if (useridd == null) {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      } else {
        $("#myModal").modal("show");
        this.seePhone = this.showphone + "(" + this.fdname + ")";
      }
    },
    // 显示私盘信息电话
    showusername() {
      var usernames = this.user_name;
      this.$alert(usernames, "请联系", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "success",
            message: `已查看`,
          });
        },
      });
    },
    fangtmark(d) {
      // var useridd = sessionStorage.getItem("userid");
      var useridd = this.$cookies.get("userid");
      if (useridd == null) {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      } else {
        if (d == 2) {
          this.loadinggone = true;
        }
        if (d == 1) {
          this.loadinggtwo = true;
        }

        if (d == 3) {
          this.loadinggthree = true;
        }
        var param = {
          house_id: this.houseidd,
          user_id: useridd,
          mark_status: d,
        };
        https
          .fetchPost("/house-detail/mark", qs.stringify(param))
          .then((data) => {
            this.loadinggone = false;
            this.loadinggtwo = false;
            this.loadinggthree = false;
            $("#myModal").modal("hide");
            $("#myModaltwo").modal("show");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    downloadphoto() {
      // var useridd = sessionStorage.getItem("userid");
      var useridd = this.$cookies.get("userid");
      if (useridd == null) {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      } else {
        window.location.href =
          "https://www.zhiyefangdong.com/house-detail/download?id=" +
          this.houseidd;
      }
    },

    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    onAlertClose() {
      this.showAlert = false;
    },
  },
  created() {
    var houseid = this.$route.query.houseid;
    // var userid = sessionStorage.getItem("userid");
    var userid = this.$cookies.get("userid");

    // alert(houseid)
    this.houseidd = houseid;
    var param = {
      id: houseid,
      user_id: userid,
    };

    https
      .fetchPost("/house-detail/house-detail", qs.stringify(param))
      .then((data) => {
        console.log(data.data);
        this.imglist = data.data.house_detail.imgurl;
        this.coverimg =
          data.data.house_detail.imgurl.length > 0
            ? data.data.house_detail.imgurl[0]
            : "";
        this.housetitle = data.data.house_detail.village_name;
        this.houselou = data.data.house_detail.building_no;
        this.househao = data.data.house_detail.room_no;
        this.houseprice = data.data.house_detail.rental;
        this.houseyongjin = data.data.house_detail.commission;
        this.houseyajin = data.data.house_detail.and;
        this.housefuzu = data.data.house_detail.pay;
        this.housename = data.data.house_detail.village_name;
        this.houseroom = data.data.house_detail.room;
        this.houseting = data.data.house_detail.hall;
        this.housewei = data.data.house_detail.bathrooms;
        this.housetype = data.data.house_detail.houseType.name;
        this.housequyu = data.data.house_detail.houseArea.name;
        this.housexianlu = data.data.house_detail.subway;
        this.housestation = data.data.house_detail.station;
        this.houssesize = data.data.house_detail.size;
        this.fdname = data.data.house_detail.landlord_name;
        this.sheshidata = data.data.facilities;
        this.showphone = data.data.house_detail.landlord_phone;
        this.housejianjie = data.data.house_detail.introduction;
        this.user_name = data.data.user_name;
        this.to_uid = data.data.house_detail.user_id;
        this.to_name = data.data.user_info.username;
        this.to_avatarimg = data.data.user_info.avatarimg;
        this.getSearchLocalhost();
      })
      .catch((err) => {
        console.log(err);
      });
    //小程序二维码扫描
    https
      .fetchPost("/house-detail/qrcode", qs.stringify({ id: houseid }))
      .then((data) => {
        this.qrcodeimg = data.data;
      });
    // alert(houseid)
  },
};
</script>
<style src="../assets/css/bootstrap.min.css" scoped></style>
<style scoped>
.content {
  margin: 40px 0;
}
.content .des {
  margin-bottom: 50px;
}
.content h2 {
  font-size: 18px;
  text-align: left;
  padding: 5px 6px;
  border-left: #000 4px solid;
  margin: 0;
  margin-bottom: 15px;
}
.content .des ul {
  margin: 0;
}
.content .des ul li {
  padding: 10px 20px;
}
.content .des p {
  text-align: left;
}
.qrcode {
  position: fixed;
  top: 55%;
  right: 10px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
}
.qrcode img {
  width: 120px;
  height: 120px;
}
.qrcode p {
  margin: 0;
  padding: 5px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.chat {
  position: fixed;
  top: 80%;
  right: 3%;
  border-radius: 10px;
  cursor: pointer;
  /* box-shadow: 0 0 6px rgba(0, 0, 0, 0.1); */
  /* padding: 10px; */
}
.chat img {
  width: 60px;
  height: 60px;
}
.chat p {
  margin: 0;
  padding: 5px 0;
  /* border-top: 1px solid rgba(0, 0, 0, 0.1); */
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
}

.blink {
  animation: blink 1s infinite;
}
.ultospan span {
  margin-left: 10px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.fangtai1 {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  cursor: pointer;
  margin-bottom: 22px;
}

.fangtaifg {
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
  margin-top: 17px;
  justify-content: center;
}

.fangtaifg img {
  width: 150px;
}

.calldata {
  margin-top: -1px;
  margin-bottom: 28px;
}

.fangtai2 {
  color: #fff;
  background: #31b573;
  padding: 9px 25px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #31b573;
}

.fangtai3 {
  color: #fff;
  background: #e60012;
  padding: 9px 25px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e60012;
}

.fangtai4 {
  color: #fff;
  background: #1268d3;
  padding: 9px 25px;
  border-radius: 4px;
  border: 1px solid #1268d3;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.housedetail1 {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.housedetail2 {
  color: #347beb;
  font-size: 25px;
}

.housedetail3 {
  color: red;
}

.housedetail4 {
  border-bottom: 1px solid #bbbaba;
  margin-top: 25px;
  width: 95%;
  margin-left: 48px;
}
.housedetail5 {
  margin-top: 15px;
}

.housedetail6 {
  color: #919396;
}

.housedetail7 {
  color: #000;
  margin-left: 23px;
}

.housedetail8 {
  text-align: right;
  margin-left: -48px;
}

.housedetail8copy {
  text-align: right;
  margin-left: -17px;
}

.housedetail9 {
  text-align: left;
  margin-left: -34px;
}

.housedetail10 {
  color: #fff;
  background: #000;
  padding: 12px 25px;
  cursor: pointer;
  white-space: nowrap;
}

.housedetail11 {
  border-bottom: 1px solid #bbbaba;
  margin-top: 33px;
  width: 95%;
  margin-left: 48px;
}

.housedetail12 {
  color: #fff;
  background: #1268d3;
  padding: 17px 85px;
  cursor: pointer;
  float: left;
  margin-left: 52px;
}

.housedetail13 {
  border-left: 4px solid #000;
  padding: 5px 6px;
}

.housedetail14 {
  margin-top: 40px;
  text-align: left;
  margin-left: 5px;
}
</style>

<style>
.safety-content .safety-icon {
  width: 200px;
}
</style>
